import { combineReducers } from 'redux';
import searchReducer from './searchReducer';
import recentAddressReducer from './recentAddressReducer';
import placesReducer from './placesReducer';

export default combineReducers({
  search: searchReducer,
  recentAddresses: recentAddressReducer,
  places: placesReducer,
});
